const BiometryTypesEnum = Object.freeze({
  Touch_ID: 'Touch ID',
  Face_ID: 'Face ID',
  Biometrics: 'Biometrics',
});

export default BiometryTypesEnum;
